module.exports = __webpack_public_path__ + "static/media/delete.d0ab9d90.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assert/images/delete.svg
// module id = 3228
// module chunks = 1